<template>
    <div class="content-body tenant-settings">
        <div class="">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item label="索赔单号" prop="claCode">
                    <el-input clearable size="mini" v-model="dataForm.claCode"  style="width: 150px " placeholder="索赔单号" @blur="getDataList"></el-input>
                </el-form-item>
                <el-form-item label="索赔月份" label-width="80px">
                    <el-date-picker
                        v-model="dataForm.claDate1"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="选择日期"
                        @blur="getDataList">
                    </el-date-picker>
                    至
                   <el-date-picker
                       v-model="dataForm.claDate2"
                       type="month"
                       value-format="yyyy-MM"
                       placeholder="选择日期"
                       @blur="getDataList">
                   </el-date-picker>
                </el-form-item>
                <el-form-item label="索赔状态" v-if="isAuth('sourcing:supplierClaManage:importButton')" label-width="78px">
                    <el-select v-model="dataForm.status" clearable placeholder="请选择" @change="getDataList">
                        <el-option v-for="item in CLA_STATUS_VALUE" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="索赔状态" v-if="!isAuth('sourcing:supplierClaManage:importButton')" label-width="78px">
                    <el-select v-model="dataForm.status" clearable placeholder="请选择" @change="getDataList">
                        <el-option v-for="item in CLA_STATUS_VALUE.filter(el=> el.value != 0)" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商名称" prop="venderName">
                    <el-input clearable size="mini" v-model="dataForm.venderName"  style="width: 150px " placeholder="供应商名称" @blur="getDataList"></el-input>
                </el-form-item>
                <el-form-item label="导入日期" label-width="80px">
                    <el-date-picker
                        v-model="dataForm.importDate1"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        @blur="getDataList">
                    </el-date-picker>
                    至
                    <el-date-picker
                        v-model="dataForm.importDate2"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        @blur="getDataList">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="fr">
                    <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:0px">查询
                    </el-button>
                    <el-button size="mini" v-if="isAuth('sourcing:supplierClaManage:importButton')" @click="createData()" icon="el-icon-plus">导入</el-button>
                    <el-button size="mini" @click="batchPublish()">批量发布</el-button>
                    <el-button size="mini" @click="batchCancelPublish()">批量取消发布</el-button>
                    <el-button size="mini" @click="batchDelete()">批量删除</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" style="width: 100%;" :header-cell-style="{background:'#f5f5f5'}"
            :row-class-name="rowClassName" :default-expand-all="false" @selection-change="selectionChangeHandle" border :height="tableHeight">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column header-align="center" label="序号" align="center" width="50">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <el-table-column prop="claCode" header-align="center" align="center" label="索赔单号" min-width="100">
                <template slot-scope="scope">
                    {{ scope.row.claCode }}
                </template>
            </el-table-column>
            <el-table-column prop="ym" header-align="center" align="center" label="索赔月份" min-width="100">
                <template slot-scope="scope">
                    {{ scope.row.ym }}
                </template>
            </el-table-column>
            <el-table-column prop="venderCode" header-align="center" align="center" label="供应商代码" min-width="100">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="center" label="供应商名称" min-width="150">
                <template slot-scope="scope">
                    {{ scope.row.venderName }}
                </template>
            </el-table-column>
             <el-table-column prop="totalSum" header-align="center" align="right" label="索赔单总金额" min-width="100">
                 <template slot-scope="scope">
                    {{ scope.row.totalSum }}
                 </template>
             </el-table-column>

            <el-table-column prop="status" header-align="center" align="center" label="状态" min-width="70">
                <template slot-scope="scope">
                    {{ scope.row.statusStr }}
                </template>
            </el-table-column>
            <el-table-column prop="createByName" header-align="center" align="center" label="导入者" min-width="100" >
                <template slot-scope="scope">
                    {{ scope.row.createByName }}
                </template>
            </el-table-column>
            <el-table-column prop="createTimeStr" header-align="center" align="center" label="导入日期" min-width="160" >
                <template slot-scope="scope">
                    {{ scope.row.createTimeStr }}
                </template>
            </el-table-column>
            <el-table-column prop="updatedName" header-align="center" align="center" label="更新人" min-width="100" >
                <template slot-scope="scope">
                    {{ scope.row.updatedName }}
                </template>
            </el-table-column>
            <el-table-column prop="updateTimeStr" header-align="center" align="center" label="更新日期" min-width="160" >
                <template slot-scope="scope">
                    {{ scope.row.updateTimeStr }}
                </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作" width="250px">
                <template slot-scope="{row}">
                    <el-button type="text" size="small" @click="viewHandle(row)" >查看</el-button>
                    <el-button :disabled="!isAuth('sourcing:supplierClaManage:importButton') || row.status != 0" type="text" size="small" @click="publishHandle(row)" >发布</el-button>
                    <el-button :disabled="!isAuth('sourcing:supplierClaManage:importButton') || row.status != 1" type="text" size="small" @click="cancelPublishHandle(row)" >取消发布</el-button>
                    <el-button :disabled="!isAuth('sourcing:supplierClaManage:importButton') || row.status != 1" type="text" size="small" @click="closeHandle(row)" >关闭</el-button>
                    <el-button :disabled="!isAuth('sourcing:supplierClaManage:importButton') || row.status != 0" type="text" size="small" @click="deleteHandle(row)" class="button-danger" icon="el-icon-delete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>
        <!-- 弹窗导入索赔信息解密那 -->
        <el-dialog title="导入索赔信息" width="40%" :visible.sync="dialogVisible" @close='closeDialog'>
            <el-form :model="dataForm1" ref="dataForm1" @keyup.enter.native="dataFormSubmit()"
                     label-width="80px" class="tenant-dialog-form">
                <el-form-item label="导入模板" prop="file">
                    <el-upload
                            ref="upload"
                            :auto-upload="false"
                            drag
                            action
                            :http-request="upload"
                            :limit="1"
                            accept=".xls"
                            :on-change="fileChange"
                            :on-remove="fileRemove"
                             :file-list="dataForm1.fileList"
                            multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div cla3ss="el-upload__tip" slot="tip">只能上传xls文件，且不超过500kb</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="exportTemplate()">
                    <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;导出模板
                </el-button>
                <el-button size="small" @click="dialogVisible = false">取消
                </el-button>
                <el-button size="small" type="primary" @click="dataFormSubmit()">确定
                </el-button>
            </span>
        </el-dialog>
        <!-- 弹窗, 查看详细信息 -->
        <supplier-cla-view v-if="viewVisible" ref="viewDetail" ></supplier-cla-view>
        <error-message v-if="errorMessageVisible" ref="errorMessage"></error-message>
    </div>
</template>
<script>
import {
    listSupplierCla,exportCLATemplate,importSupplierCla,publishSupplierCla,
    cancelPublishSupplierCla,deleteSupplierCla,closeSupplierCla,getSupplierEva,
    batchPublishCla,batchCancelPublishCla,batchDelete
} from '@/controller/supplier'
import {
    getLabelByValue,
    CLA_STATUS_VALUE
} from "@/utils/const"
import {getPreMonth} from '@/utils/common'
import supplierClaView from "./supplier-cla-view";
import ErrorMessage from './error-message'
    export default {
        data() {
            return {
                submitLoading:false,
                dialogVisible: false,
                dataForm: {
                    key: '',
                    claCode: '',
                    claDate1: '',
                    claDate2: '',
                    status: '',
                    venderName: '',
                    importDate1: '',
                    importDate2: '',
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                something: '',
                dataForm1: {
                    id: 0,
                    fileList:[],
                    file: null
                },
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
                    }
                },
                getLabelByValue: getLabelByValue,
                CLA_STATUS_VALUE: CLA_STATUS_VALUE,
                viewVisible: false,
            }
        },
        components: {
            supplierClaView,
            ErrorMessage,
        },
        computed: {
            tableHeight: {
                get() {
                    return this.$store.state.common.documentClientHeight - 260
                }
            }
        },
        activated() {
          this.getDataList()
        },
        created() {
            //this.dataForm.claDate1 = getPreMonth()
            //this.getDataList()
        },
        methods: {

            fileChange(uploadFile,fileList) {
                this.dataForm1.file = uploadFile
                if(fileList.length !== 0) {
                    this.$refs.dataForm1.validateField('file')
                }
            },
            fileRemove(uploadFile,fileList) {
                if(fileList.length === 0) {
                    this.dataForm1.file = null
                    this.$refs.dataForm1.validateField('file')
                }
            },
            dateFormat: function (row, column) {
              var date = row[column.property]
              if (!date) {
                  return ''
              }
              return moment(date).format("YYYY-MM-DD HH:mm:ss")
            },
        
            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                var claDate1 = this.dataForm.claDate1
                var claDate2 = this.dataForm.claDate2
                if(claDate2 != null && claDate2 != "" && claDate1 > claDate2) {
                    this.$message.warning("索赔月份输入有误，截止月份应大于等于起始月份！")
                    return
                }
                var importDate1 = this.dataForm.importDate1
                var importDate2 = this.dataForm.importDate2
                if(importDate2 != null && importDate2 != "" && importDate1 > importDate2) {
                    this.$message.warning("导入日期输入有误，截止日期应大于等于起始日期！")
                    return
                }
                debugger
                this.dataListLoading = true
                listSupplierCla({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'claCode': this.dataForm.claCode,
                    'claDate1': claDate1,
                    'claDate2': claDate2,
                    'status': this.dataForm.status,
                    'venderName': this.dataForm.venderName,
                    'importDate1': this.dataForm.importDate1,
                    'importDate2': this.dataForm.importDate2,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total

                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm1'].validate((valid) => {
                    if (valid) {
                        this.$refs.upload.submit();
                    }
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                console.log(val)
                this.dataListSelections = val
            },
            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },
            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },
            //批量发布
            batchPublish(){
                if(this.dataListSelections.length == 0){
                    this.$message.warning("请选择数据")
                    return
                }
                const ids = [];
                for (let index = 0; index < this.dataListSelections.length; index++) {
                    var cla = this.dataListSelections[index];
                    if(cla.status == 0) {
                        ids.push(cla.id);
                    }
                }
                if(ids.length == 0){
                    this.$message.warning("请选择草稿数据发布")
                    return
                }
                this.$confirm('确定批量发布吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    batchPublishCla(ids).then(data => {
                     if(data.code === '00'){
                        this.$message.success({
                          message: '发布完成',
                          type: 'success',
                          duration: 1500,
                          onClose: () => {
                              this.getDataList()
                              //this.$emit("refreshDataList")
                          }
                      })
                     }else{
                          this.$message.error(data.msg);
                     }
                  })
                })
            },
            //批量取消发布
            batchCancelPublish(){
                debugger
                if(this.dataListSelections.length == 0){
                    this.$message.warning("请选择数据")
                    return
                }
                const ids = [];
                for (let index = 0; index < this.dataListSelections.length; index++) {
                    var cla = this.dataListSelections[index];
                    debugger
                    if(cla.status == 1) {
                        ids.push(cla.id);
                    }
                }
                if(ids.length == 0){
                    this.$message.warning("请选择已发布数据")
                    return
                }
                this.$confirm('确定取消批量发布吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    batchCancelPublishCla(ids).then(data => {
                     if(data.code === '00'){
                        this.$message.success({
                          message: '取消发布完成',
                          type: 'success',
                          duration: 1500,
                          onClose: () => {
                              this.getDataList()
                              //this.$emit("refreshDataList")
                          }
                      })
                     }else{
                          this.$message.error(data.msg);
                     }
                  })
                })
            },
            //批量删除
            batchDelete(){
                if(this.dataListSelections.length == 0){
                    this.$message.warning("请选择数据")
                    return
                }
                const ids = [];
                for (let index = 0; index < this.dataListSelections.length; index++) {
                    var cla = this.dataListSelections[index];
                    if(cla.status == 0) {
                        ids.push(cla.id);
                    }
                }
                if(ids.length == 0){
                    this.$message.warning("请选择草稿数据删除")
                    return
                }
                this.$confirm('确定删除操作吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    batchDelete(ids).then(data => {
                     if(data.code === '00'){
                        this.$message.success({
                          message: '删除完成',
                          type: 'success',
                          duration: 1500,
                          onClose: () => {
                              this.getDataList()
                              //this.$emit("refreshDataList")
                          }
                      })
                     }else{
                          this.$message.error(data.msg);
                     }
                  })
                })
            },
            //查看
            viewHandle(row) {
                this.viewVisible = true
                this.$nextTick(() => {
                    this.$refs.viewDetail.init(row);
                })
            },
            //发布
            publishHandle(row) {
                publishSupplierCla({
                    id: row.id
                }).then(data => {
                    if (data && data.code === '00') {
                        this.getDataList()
                    }
                });
            },
            //取消发布
            cancelPublishHandle(row) {
                cancelPublishSupplierCla({
                    id: row.id
                }).then(data => {
                    if (data && data.code === '00') {
                        this.getDataList()
                    }
                });
            },
            // 删除
            deleteHandle(row) {
                this.$confirm(`确定进行删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    debugger
                    deleteSupplierCla({
                        id: row.id
                    }).then(data => {
                        if (data && data.code === '00') {
                            this.getDataList()
                        }
                    });
                })
            },
            //关闭
            closeHandle(row) {
                closeSupplierCla({
                    id: row.id
                }).then(data => {
                    if (data && data.code === '00') {
                        this.getDataList()
                    }
                });
            },
            // 新增
            createData() {
                debugger
                this.dataForm1.file = null
                this.dataForm1.fileList = []
                this.dialogVisible = true
            },
            statusFormat: function (value) {
                if (!value) {
                    return "";
                }
                debugger
                return getLabelByValue(CLA_STATUS_VALUE, value);
            },
            // 导出模板
            exportTemplate() {
                exportCLATemplate().then((data) => {
                    this.readAsBinaryString(data.body)
                })
            },
            readAsBinaryString(data) {
                // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
                // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
                let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
                dom.style.display = 'none';
                dom.href = url;
                dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
                document.body.appendChild(dom);
                dom.click();
            },
            str2Blob(str, mime) {
                var arr = str.split(',')
                var bstr = atob(arr[0]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                });
            },
            upload(obj) {
                let formData = new FormData()
                formData.set('file', obj.file)
                importSupplierCla(formData).then((data) => {
                    if(data.code === '00'){
                        this.$refs.upload.clearFiles()
                        this.$message.success({
                          message: '导入成功',
                          type: 'success',
                          duration: 1500,
                          onClose: () => {
                              this.dialogVisible = false
                              this.getDataList()
                          }
                        })
                    } else {
                        //this.$message.error(data.msg);
                        this.dialogVisible = false
                        this.errorMessageVisible = true
                        this.$nextTick(() => {
                            this.$refs.errorMessage.init(data.msg)
                        })
                    }
                }).catch((e) => {
                    this.dialogVisible = false
                    this.$message.error(e);
                })
            },
        }
    }
</script>

<style lang="scss">
    .fr { float: right; }

    .button-danger { color: #F56C6C; }
</style>